import { render, staticRenderFns } from "./EditExpense.vue?vue&type=template&id=3a955c49&"
import script from "./EditExpense.vue?vue&type=script&lang=js&"
export * from "./EditExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports